import { Check, Close } from '@mui/icons-material';
import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { dateToString, timeToString } from 'utils/date';

const AppTable = ({
  titles,
  rows,
  isEdit = false,
  isDelete = false,
  isAction = false,
  isComplete = false,
  onAction,
  onComplete,
  onDelete,
  customActions = [],
  onCustomAction,
  pageKey,
  pageNumber,
  hideRows = '',
  pageItems = 10
}) => {
  const [, setSearchParams] = useSearchParams();
  const [brokens, setBrokens] = useState([]);
  const getValue = value => {
    if (typeof value === 'string') {
      if (value.substring(0, 4) === 'http') {
        if (value.includes('youtube')) {
          return <a href={value}>{value}</a>;
        }
        return brokens.includes(value) ? (
          <a
            className={'underline'}
            target={'_blank'}
            rel="noreferrer"
            href={value}
          >
            Belge
          </a>
        ) : (
          <img
            onError={() => setBrokens(oldState => [...oldState, value])}
            src={value}
            className="h-12"
          />
        );
      }

      if (!isNaN(new Date(value).getDate()) && value.length > 15) {
        return `${dateToString(value)} ${timeToString(value)}`;
      }

      return value;
    }

    if (typeof value === 'boolean') {
      return value ? <Check /> : <Close />;
    }

    if (typeof value === 'number') {
      return value;
    }

    if (value && value.length > 0) {
      if (value[0].lang) {
        return value[0].value;
      }
    }

    if (typeof value === 'object' && value.name) {
      if (value.name && value.name.length > 0 && Array.isArray(value.name)) {
        return value.name[0].value;
      }
    }

    return value.name;
  };

  const checkValue = key => {
    const splitHiddenRows = hideRows.split(',');
    const getKey = typeof key === 'string' ? key : key.name;
    const findRow = splitHiddenRows.find(row => getKey === row.trim());
    if (findRow) {
      return false;
    }

    return true;
  };

  const confirmDelete = id => {
    if (window.confirm('Silme işlemi geri alınamaz. Onaylıyor musunuz?')) {
      onDelete(id);
    }
  };

  return (
    <>
      <div className="overflow-x-auto relative rounded-lg">
        {rows && rows.length > 0 ? (
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-500 uppercase bg-gray-100">
              <tr>
                <th scope="col" className="py-4 px-6">
                  #
                </th>
                {titles.map((title, index) => (
                  <th scope="col" className="py-4 px-6" key={`title${index}`}>
                    {title}
                  </th>
                ))}
                {isEdit && (
                  <th scope="col" className="py-4 px-6">
                    Düzenle
                  </th>
                )}
                {isAction && (
                  <th scope="col" className="py-4 px-6">
                    İŞLEM
                  </th>
                )}
                {isComplete && (
                  <th scope="col" className="py-4 px-6">
                    TAMAMLA
                  </th>
                )}
                {customActions.length > 0 && (
                  <th scope="col" className="py-4 px-6">
                    İŞLEM
                  </th>
                )}
                {isDelete && (
                  <th scope="col" className="py-4 px-6">
                    SİL
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr className="bg-white border-b" key={`tr${index}`}>
                  <td className="px-6 py-4" key={`index${index}`}>
                    {index + 1 + (pageNumber - 1) * pageItems}
                  </td>
                  {Object.keys(row).map(
                    (key, index) =>
                      checkValue(key) && (
                        <td className="py-3 px-6" key={`row${index}`}>
                          {getValue(row[key])}
                        </td>
                      )
                  )}
                  {isEdit && (
                    <td className="py-3 px-6">
                      <Link
                        to={`/${pageKey}/add?id=${row._id}`}
                        className="px-3 py-2 text-xs font-medium text-center text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 cursor-pointer"
                      >
                        Düzenle
                      </Link>
                    </td>
                  )}
                  {isAction && (
                    <td className="py-3 px-6">
                      {row.status === 'pending' ? (
                        <div className={'flex gap-2'}>
                          <button
                            onClick={() => onAction(row, 'approved')}
                            className="px-3 py-2 text-xs font-medium text-center text-white bg-green-600 rounded-lg hover:bg-green-700 focus:ring-4 focus:outline-none focus:ring-green-300 cursor-pointer"
                          >
                            ONAYLA
                          </button>
                          <button
                            onClick={() => onAction(row, 'rejected')}
                            className="px-3 py-2 text-xs font-medium text-center text-white bg-red-600 rounded-lg hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 cursor-pointer"
                          >
                            REDDET
                          </button>
                        </div>
                      ) : (
                        '-'
                      )}
                    </td>
                  )}
                  {isComplete && (
                    <td className="py-3 px-6">
                      {row.status === 'approved' ? (
                        <div className={'flex gap-2'}>
                          <button
                            onClick={() => onComplete(row, 'completed')}
                            className="px-3 py-2 text-xs font-medium text-center text-white bg-green-600 rounded-lg hover:bg-green-700 focus:ring-4 focus:outline-none focus:ring-green-300 cursor-pointer"
                          >
                            TAMAMLANDI
                          </button>
                        </div>
                      ) : (
                        '-'
                      )}
                    </td>
                  )}
                  {customActions.length > 0 && (
                    <td className="py-3 px-6">
                      <div className={'flex gap-2'}>
                        {customActions.map((action, index) => (
                          <button
                            key={`action${index}`}
                            onClick={() => onCustomAction(row, action.type)}
                            className={`px-3 py-2 text-xs font-medium text-center text-white bg-yellow-600 rounded-lg hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 cursor-pointer`}
                          >
                            {action.title}
                          </button>
                        ))}
                      </div>
                    </td>
                  )}
                  {isDelete && (
                    <td className="py-3 px-6">
                      <button
                        onClick={() => confirmDelete(row._id)}
                        className="px-3 py-2 text-xs font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 cursor-pointer"
                      >
                        SİL
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center px-10 py-10 text-xl text-gray-500">
            Herhangi bir data bulunamadı.
          </div>
        )}
      </div>
      <div className="flex align-middle mt-4 justify-between">
        {pageNumber > 1 ? (
          <button
            // @ts-ignore
            onClick={() => setSearchParams({ page: pageNumber - 1 })}
            className="inline-flex items-center py-2 px-4 mr-3 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
          >
            <svg
              aria-hidden="true"
              className="mr-2 w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
            Geri
          </button>
        ) : (
          <div></div>
        )}
        {rows && rows.length === pageItems ? (
          <button
            onClick={() => setSearchParams({ page: pageNumber + 1 })}
            className="inline-flex items-center py-2 px-4 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
          >
            İleri
            <svg
              aria-hidden="true"
              className="ml-2 w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        ) : (
          <div></div>
        )}
      </div>
    </>
  );
};

export default AppTable;
